import { SipType } from "../../model/sipType";
import { asSelectOptions, SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipType;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getSipTypes(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(apiUrls.getSipTypes);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = asSelectOptions({
        data: response.data,
        doFilter: true,
        doSort: false,
      });
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error fetching sipTypes:", err);
    return { error: (err as Error).message };
  }
}
